<template>
  <v-app id="app">
    <v-main>
      <slot />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: 'potree-layout',
};
</script>

<style>
@import '../styles/main.css';

#app {
  width: 100vw;
  height: 100vh;
}
</style>
